<template>
    <b-container>
        <div class="error d-flex flex-column justify-content-between align-items-center">
            <h1>{{ $t('Components_Special_ErrorPage_1') }}</h1>
            <img src="@/assets/img/error-404.png" alt="" />
        </div>
    </b-container>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.error {
    margin-top: 20px;
    height: 50vh;
    width: 100%;
    h1 {
        max-width: 70%;
        color: white;
        margin-bottom: 2em;
        text-align: center;
    }
    img {
        width: 50%;
        height: auto;
    }
}

//Responsividade
@media (max-width: 576px) {
    h1 {
        font-size: 28px !important;
    }
}
</style>
